class SlideshowComponent extends HTMLElement {
	constructor() {
		super()
		this.selectors = {
			contents: ['.f-slideshow__content-wrapper'],
			selected: '.selected',
			flickity: 'flickity-component',
			pageDots: '.flickity-page-dots',
			pageCounter: '.flickity-page-counter'
		}
		this.domNodes = queryDomNodes(this.selectors, this)
		this.prevIndex = 0
		// Проверяем, является ли это biky-slideshow
		this.isBikySlideshow = this.closest('.biky-slideshow') !== null
		this.init()
	}

	disconnectedCallback() {
		clearInterval(this.check)
		// Удаляем обработчики для biky-slideshow
		if (this.isBikySlideshow && this.bikyNavHandlers) {
			this.bikyNavHandlers.forEach(handler => {
				if (handler.element && handler.event) {
					handler.element.removeEventListener(handler.event, handler.callback)
				}
			})
		}
	}

	init() {
		this.check = setInterval(() => {
			this.slider = this.domNodes.flickity.slider && this.domNodes.flickity.slider.instance
			if (this.slider && typeof this.slider == 'object') {
				clearInterval(this.check)
				this.removeAttribute('data-media-loading')
				this.slider.on('change', this.handleChange.bind(this))
				this.domNodes.contents[0].classList.add('selected')
				this.handleScreenChange()
				this.playVideo()
				if (this.domNodes.pageCounter) {
					this.domNodes.flickity.insertBefore(this.domNodes.pageCounter, null)
				}
				// Инициализируем кастомную навигацию для biky-slideshow
				if (this.isBikySlideshow) {
					this.initBikyNavigation()
				}
			}
		}, 200)
	}

	initBikyNavigation() {
		// Находим элементы кастомной навигации
		const navPrev = this.querySelector('.biky-slideshow__nav--prev')
		const navNext = this.querySelector('.biky-slideshow__nav--next')
		const dots = this.querySelectorAll('.biky-slideshow__dot')

		this.bikyNavHandlers = []

		// Обработчик для кнопки "Назад"
		if (navPrev) {
			const prevHandler = () => {
				if (this.slider) {
					this.slider.previous()
				}
			}
			navPrev.addEventListener('click', prevHandler)
			this.bikyNavHandlers.push({ element: navPrev, event: 'click', callback: prevHandler })
		}

		// Обработчик для кнопки "Вперед"
		if (navNext) {
			const nextHandler = () => {
				if (this.slider) {
					this.slider.next()
				}
			}
			navNext.addEventListener('click', nextHandler)
			this.bikyNavHandlers.push({ element: navNext, event: 'click', callback: nextHandler })
		}

		// Обработчики для точек навигации
		dots.forEach((dot, index) => {
			const dotHandler = () => {
				if (this.slider) {
					this.slider.select(index)
				}
			}
			dot.addEventListener('click', dotHandler)
			this.bikyNavHandlers.push({ element: dot, event: 'click', callback: dotHandler })
		})

		// Инициализируем состояние навигации
		this.updateBikyNavigationState(0)
	}

	updateBikyNavigationState(index) {
		if (!this.isBikySlideshow || !this.slider) return

		const navPrev = this.querySelector('.biky-slideshow__nav--prev')
		const navNext = this.querySelector('.biky-slideshow__nav--next')
		const dots = this.querySelectorAll('.biky-slideshow__dot')
		const totalSlides = this.slider.slides ? this.slider.slides.length : 0

		// Обновляем состояние кнопок навигации
		if (navPrev) {
			// Отключаем кнопку "Назад" только если это первый слайд и нет wrapAround
			if (index === 0 && !this.slider.options.wrapAround) {
				navPrev.disabled = true
				navPrev.setAttribute('aria-disabled', 'true')
			} else {
				navPrev.disabled = false
				navPrev.removeAttribute('aria-disabled')
			}
		}

		if (navNext) {
			// Отключаем кнопку "Вперед" только если это последний слайд и нет wrapAround
			if (index === totalSlides - 1 && !this.slider.options.wrapAround) {
				navNext.disabled = true
				navNext.setAttribute('aria-disabled', 'true')
			} else {
				navNext.disabled = false
				navNext.removeAttribute('aria-disabled')
			}
		}

		// Обновляем состояние точек
		dots.forEach((dot, i) => {
			if (i === index) {
				dot.classList.add('is-selected')
				dot.setAttribute('aria-current', 'true')
			} else {
				dot.classList.remove('is-selected')
				dot.removeAttribute('aria-current')
			}
		})
	}

	handleChange(index) {
		const selected = this.querySelectorAll(this.selectors.selected)
		const sliderCounterCurrent = this.querySelector('.flickity-counter--current')

		selected.forEach(item => item.classList.remove('selected'))
		this.domNodes.contents[this.prevIndex].classList.add('f-slideshow__content--out')
		this.domNodes.contents[index].classList.add('selected')
		setTimeout(() => {
			this.domNodes.contents[this.prevIndex].classList.remove('f-slideshow__content--out')
			this.prevIndex = index
		}, 300)

		// Handle page counter
		if (this.domNodes.pageCounter && sliderCounterCurrent) {
			sliderCounterCurrent.textContent = index + 1
		}

		// Обновляем состояние кастомной навигации для biky-slideshow
		if (this.isBikySlideshow) {
			this.updateBikyNavigationState(index)
		}

		this.playVideo()
	}

	playVideo() {
		this.pauseAllMedia()
		let selectedElm = this.slider.selectedElement
		if (!selectedElm) {
			console.log('!!!');
			setTimeout(() => {
				selectedElm = this.slider.selectedElement;
				console.log('Ok?', this.slider);
				console.log('Ok?', selectedElm);
			}, 200)
		}
		const deferredMedia = selectedElm.querySelector('deferred-media')
		if (deferredMedia) {
			deferredMedia.loadContent()
			const youtube = deferredMedia.querySelector('.js-youtube')
			const vimeo = deferredMedia.querySelector('.js-vimeo')
			const video = deferredMedia.querySelector('video')
			if (video) video.play()
			if (youtube) youtube.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
			if (vimeo) vimeo.contentWindow.postMessage('{"method":"play"}', '*')
		}
	}

	pauseAllMedia() {
		this.querySelectorAll(".js-youtube").forEach((video) => {
			video.contentWindow.postMessage(
				'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
				"*"
			);
		});
		this.querySelectorAll(".js-vimeo").forEach((video) => {
			video.contentWindow.postMessage('{"method":"pause"}', "*");
		});
		this.querySelectorAll("video").forEach((video) => video.pause());
	}

	handleScreenChange() {
		if (FoxThemeSettings.isMobile) {
			// this.domNodes.flickity.toggleFade()
		}
		document.addEventListener('matchMobile', () => {
			// this.domNodes.flickity.toggleFade()
		})
		document.addEventListener('unmatchMobile', () => {
			// this.domNodes.flickity.toggleFade(true)
		})
	}
}

customElements.define('slideshow-component', SlideshowComponent)